import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-notification',
  templateUrl: './custom-notification.component.html',
  styleUrl: './custom-notification.component.scss'
})
export class CustomNotificationComponent {
  content = "";
}
